import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcChat24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m18.995 2c1.62 0 3.005 1.22 3.005 2.793v10.188c0 1.597-1.22 3.005-2.817 3.005h-11.243c-.188 0-.423.047-.587.211l-3.663 3.521a.957.957 0 0 1 -.68.282c-.51 0-1.01-.5-1.01-1v-16c0-1.677 1.37-3 3-3zm-14.01 1.995c-.538 0-.985.505-.985 1.005v13.643l1.854-1.83c.47-.423 1.08-.799 1.69-.799l11.456-.014c.54 0 1-.484 1-1v-10c0-.493-.484-1-1-1l-14.014-.005zm12.015 7.005c.565 0 1 .437 1 1s-.482 1-1 1l-10.012-.005c-.565 0-.988-.446-.988-1.01 0-.563.506-.985 1-.985zm.012-4a1 1 0 0 1 -.012 2l-10.012-.005c-.565 0-.988-.395-.988-.995s.506-1 1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcChat24;
